module.exports = __webpack_public_path__ + "img/gkrytlqh.b1dabdb4.png";